// extracted by mini-css-extract-plugin
module.exports = {"pcItem":"pcItem___1SN_d","title":"title___2WgAr","img":"img___2wnlQ","mobileItem":"mobileItem___1mOlu"};